import { Box, Center } from "@chakra-ui/react";
import ShareBg from "@images/share_bg.png";
import MediaCover from "@modules/Layout/components/MediaCustomCover";
import { BannerHero } from "@modules/Layout/style";
import { Banner } from "@types/common";
import React, { memo } from "react";
import { Else, If, Then } from "react-if";
import BannerCropFluidImage from "./BannerCropFluidImage";
import ResponsiveContainer from "./ResponsiveContainer";

interface Props {
  banner: Banner;
  bg?: string;
  typeImage?: "cover" | "crop" | null;
}

const CoverBannerCrop: React.FC<Props> = ({
  banner,
  bg = "white50",
  typeImage,
}) => {
  const { heading_bg, media_type: bannerType } = banner || {};
  const headingBgUrl = heading_bg?.url;

  return (
    <Box>
      {bannerType === "video" && (
        <BannerHero>
          <Box
            pt={12}
            pb={{ base: 0, md: 12 }}
            height={"100%"}
            position="relative"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
          >
            <Center height="100%">
              <ResponsiveContainer px={{ base: 0, md: 7, lg: 12 }}>
                <MediaCover data={banner} />
              </ResponsiveContainer>
            </Center>
          </Box>
        </BannerHero>
      )}
      {bannerType === "image" && (
        <BannerHero>
          <If condition={!!headingBgUrl}>
            <Then>
              <Box
                pb={{ base: 4, md: 7 }}
                height={"100%"}
                position="relative"
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                backgroundSize="cover"
                backgroundImage={`url(${ShareBg})`}
              >
                <BannerCropFluidImage
                  data={banner}
                  coverBorder="lg"
                  typeImage={typeImage}
                />
              </Box>
            </Then>
            <Else>
              <Box bg={bg}>
                <BannerCropFluidImage
                  data={banner}
                  contentWidth="lg"
                  typeImage={typeImage}
                />
              </Box>
            </Else>
          </If>
        </BannerHero>
      )}
    </Box>
  );
};

export default memo(CoverBannerCrop);
